<template>
  <div class="row" :class="{'row_stem-expo': this.isStemExpo, 'fixed-row-height': this.$isEngCom }">
    <div v-if="isStemHall" class="sponsor_box">
      <p class="sponsor_box_text"></p>
      <img class="sponsor_box_logo" src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/IsefResources%2Fbroadcomlogo.png?alt=media&token=5d0f4772-0eda-4fd8-9337-e25045538336" />
    </div>
    <div class="is-flex" :class="{'is-flex-direction-row' : $isIsef}">
      <!-- Category Image -->
      <div v-if="categorySlug && category.image"
           class="category-image-container is-flex"
           :class="{'is-hidden-mobile' : !$isIsef}">
        <div v-if="this.$props.showIsefHome && $isIsef"
             class="category-image_star">
          <i class="fas fa-star"/>
        </div>
        <img v-if="!this.$props.showIsefHome"
             class="category-image"
             :class="{'category-image-isef' : $isIsef}"
             :src="this.$isIsef ? category.image : proxyCatImage(category.image)"
             :alt="`Category ${category.name}`"/>
      </div>
      <div v-if="!this.isStemExpo" :class="{'ysc': $isYSC, 'isef': this.isIsefHome, 'category-header tabs' : !$isIsef, 'tabs-isef' : $isIsef}">
        <!-- Featured/Newest/Bookmarked Row -->
        <ul v-if="title.startsWith(FEATURED_KEY)" class="featured-and-newest has-text-grey-lighter">
          <li :class="{ 'is-active' : activeTab.startsWith(FEATURED_KEY) }" @click="changeSubCategory(FEATURED_KEY)" qa="featured-row">
            <a class="main-title" :class="{'ysc' : $isYSC}">
              {{ featuredTitle }}
            </a>
          </li>
            <!--newest tab-->
          <li v-if="isViewNewestTabPermission" :class="{'is-active': activeTab == NEWEST_KEY }" @click="changeSubCategory(NEWEST_KEY)" qa="newest-row">
            <span class="line has-text-black">&nbsp;|&nbsp;</span>
            <a :class="{'ysc' : $isYSC}">{{ newestTitle }}</a>
          </li>

          <li v-if="isLoggedIn" :class="{'is-active': activeTab == BOOKMARKED_KEY }" @click="changeSubCategory(BOOKMARKED_KEY)" qa="bookmarked-row">
            <span v-if="isLoggedIn" class="line has-text-black">&nbsp;|&nbsp;</span>
            <a :class="{'ysc' : $isYSC}">{{ bookmarkedTitle }}</a>
          </li>
        </ul>
        <!-- Premium Row -->
        <ul v-else-if="title.startsWith(PREMIUM_KEY) && !this.isStemExpo" class="featured-and-newest has-text-grey-lighter">
          <li :class="{ 'is-active' : activeTab.startsWith(PREMIUM_KEY) }" @click="changeSubCategory(PREMIUM_KEY)" qa="premium-row">
            <a class="main-title" :class="{'ysc' : $isYSC}">{{ premiumTitle }}</a>
          </li>
        </ul>
        <!-- Grand Row -->
        <ul v-else-if="title.startsWith('Grand')">
          <li class="category-title" :class="{ 'is-active' : activeTab.startsWith('Grand') }" @click="changeSubCategory(OUTSTANDING)">
            <a class="main-title" :class="{'ysc' : $isYSC }">{{ $t("explore.grandAward") }}</a>
          </li>
        </ul>
        <!-- YSC Outstanding Projects Row -->
        <ul v-else-if="title.startsWith(OUTSTANDING)">
          <li class="category-title" :class="{ 'is-active' : activeTab.startsWith(OUTSTANDING) }" @click="changeSubCategory(OUTSTANDING)">
            <a class="main-title" :class="{'ysc' : $isYSC , 'isef': (isIsefHome || isCareerHall) && $isIsef}">{{ $t("explore.outstandingProjects") }}</a>
          </li>
        </ul>
        <!-- Everything else -->
        <ul v-else :class="{'category-header_project-border': this.isCareerHall || this.isCollegeHall || this.isStemHall || this.isIsefHome}" qa="header-titles">
          <li class="category-title no-wrap"
              :class="{'is-active': activeTab === title, 'category-title-isef': $isIsef }"
              @click="changeSubCategory(title)"
              v-bind="getTooltip(title)"
              tabindex="0"
              @keypress.enter.space="changeSubCategory(title)">
            <img v-if="imgSrc" class="small-ribbon" :src="imgSrc" />
            <a class="main-title" :class="{'ysc' : $isYSC, 'isef': this.isIsefHome}">{{ displayTitle }}</a>
            <span v-if="hasParentCategory" class="sub-category-title">{{ getParentName() }}</span>
          </li>
          <button class="project-button" v-if="isAcceptingProjects" @click="openMakerTemplate(title)">{{ buttonTitle }} </button>
          <li class="subcategory-list"
              :class="{'is-active': activeTab == sub, 'is-hidden': subCategories.length > 7 || showSubDropdown }"
              v-for="sub in subCategories" :key="sub.id"
              v-bind="getTooltip(sub.name)">
            <a :class="{'ysc' : $isYSC}" @click="changeSubCategory(sub)">{{ sub.name }}</a>
          </li>
          <div v-if="showSponsorLogo" class="project-sponsor-spacing is-flex-direction-row">
            <a v-if="category.sponsorLink !== ''" :href="category.sponsorLink" target="_blank" class="hover-sponsor">
              <span v-if="this.$isEngCom" class="no-wrap sponsored-by">Sponsored By</span>
              <img class="sponsor-image is-flex"
                   :aria-label="`Sponsored ad by ${category.sponsor}`"
                   :class="{'max-height' : $isYSC, 'project-sponsor-image' : $isIsef}"
                   :src="category.sponsorImage"
                   :alt="category.sponsorImage">
            </a>
            <img v-else class="sponsor-image is-flex" :aria-label="`Sponsored ad by ${category.sponsor}`" :class="{'max-height' : $isYSC}" :src="category.sponsorImage" :alt="category.sponsorImage">
          </div>
        </ul>
        <!-- subcategory drop down -->
        <div v-if="subCategories && subCategories.length > 0 && !title.startsWith(FEATURED)"
             class="dropdown is-right cursor-pointer"
             :class="{'is-active': showSubMenu, 'is-hidden': subCategories.length <= 7 && !showSubDropdown}">
          <div class="dropdown-trigger" v-if="categorySlug">
            <button class="button sub-button" aria-haspopup="true" :aria-controls="`${category.slug}-subcategory-dropdown-menu`" @click="showSubMenu = !showSubMenu">
              <span v-if="subCategories && !subSelected.name" class="sub-count has-text-weight-semibold">
                {{ subCategories.length }} subcategories
              </span>
              <span v-if="subSelected.name" class="sub-count has-text-weight-semibold">
                {{ subSelected.name }}
              </span>
              <span class="icon is-small">
                <i class="fal fa-angle-down" aria-hidden="true"></i>
              </span>
            </button>
          </div>
          <div class="dropdown-menu" :id="`${category.slug}-subcategory-dropdown-menu`" role="menu">
            <div class="dropdown-content">
              <a @click="changeSubCategory(sub, true)" class="dropdown-item is-marginless is-uppercase" v-for="sub in subCategories" :key="sub.id" :class="{'is-active': activeTab === sub}">
                {{ sub.name }}
                <span v-if="activeTab === sub"><i class="fal fa-times sub-close"></i></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showLoading && (projects && projects.length > 0)" class="card-row is-flex" ref="row" :class="{'card-row-isef' : $isIsef}" @scroll="handleScroll">
      <template v-if="(projects && projects.length > 0) && !isProjectPlaceholder">
        <div v-for="(project, index) in projects" :key="`${index}-${project.id}`">
          <project-card
              :projectID="project.id"
              :categoryID="subCategoryID || categoryID"
              :storyType="newestActive"
              :isRowLoading="isLoading" v-bind="{isPinnableRow, pinnedProjects}"
              :currentExplorePage="currentExplorePage"
              @onPinned="onPinned"
              :size="size"/>
        </div>
      </template>
      <template v-if="isProjectPlaceholder || (projects && projects.length == 0)">
        <div :class="(isCareerHall || $isIsef) ? 'empty-row-spacing empty-row-spacing_text' : 'empty-row-spacing'">
          <span v-if="$isOhioScience && activeTab !== AWARDED_PROJECTS && activeTab !== SD_AWARDED_PROJECTS && activeTab !== SD_SUPERIOR_AWARDS">{{ $t("ohioScience.noProjects") }}</span>
          <span v-if="$isSigmaXi && activeTab !== AWARDED_PROJECTS">{{ $t("sigmaxi.noProjects") }}</span>
          <span v-else-if="activeTab === BOOKMARKED_KEY">{{ $t("explore.noBookmarks") }}</span>
          <span v-else-if="activeTab === AWARDED_PROJECTS || activeTab === SD_AWARDED_PROJECTS || activeTab === SD_SUPERIOR_AWARDS || activeTab === GRAND_AWARDS">{{  $t("explore.comingSoonMessageAwardedProjects") }}</span>
          <span v-else-if="(this.isIsefHome || this.isIsefViewAll) && projectsLoadedForCategory">
            {{ userFilterIsActive ? $t("explore.noProjectsMatch") : $t('explore.noProjectsGeneral') }}
          </span>
          <span v-else>
            <div class=“loader-container”><span class="loader" /></div>
          </span>
        </div>
      </template>
      <div v-if="isScrollable"
           class="view-more is-flex"
           :class="{'view-more_text': (this.isIsefHome || this.isCareerHall) && this.$isIsef}">
        <p v-if="!this.isCareerHall">
          {{ $t("explore.seeAll") }}
        </p>
        <div v-if="!this.isCareerHall"
             class="view-category cursor-pointer"
             @click="viewAllCategory(activeTab)">
          {{ categoryFullName }}
        </div>
      </div>
      <div v-if="isScrollable" class="button-container"
           :class="{'button-container_stemexpo-large': size,
           'button-container_stemexpo' : this.isStemExpo || this.$isIsef}">
        <div v-if="canScrollLeft"
             class="scroll-button left cursor-pointer is-flex"
             :class="{'scroll-button-isef' : this.$isIsef}"
             @click="horizontalScroll('left')">
          <i class="fal fa-chevron-left" :class="{'fa-2x' : !$isIsef}" qa="scroll-row-left-arrow" />
        </div>
        <div v-if="canScrollRight"
             class="scroll-button right cursor-pointer is-flex"
             :class="{'scroll-button-isef' : this.$isIsef}"
             @click="horizontalScroll('right')">
          <i class="fal fa-chevron-right" :class="{'fa-2x' : !$isIsef}" qa="scroll-row-right-arrow" />
        </div>
      </div>
    </div>
    <div v-else class="card-row no-projects is-flex" :class="{'no-projects-isef' : $isIsef}">
      <p>{{ noProjectsMessage }}</p>
    </div>
  </div>
</template>

<script>
import breakpoints from '@/libs/breakpoints'
import userAgent from '@/libs/user-agent'
import visibility from '@/mixins/visibility'
import homepageStrings from '@/mixins/homepage'
import yscStrings from '@/mixins/ysc'
import ajasStrings from '@/mixins/ajas'
import i18n from '@/i18n'
import ProjectCard from '@/components/Cards/ProjectCards'
import imageProxy from '@/libs/image-proxy'
import auth from '@/mixins/auth'
import features from '@/mixins/features'

export default {
  name: 'projectrow',
  props: {
    title: String,
    projects: Array,
    offset: Number,
    categorySlug: String,
    rowState: Object,
    rowType: String,
    showLoading: Boolean,
    imgSrc: String,
    showParent: Boolean,
    size: [String, Number],
    showIsefHome: Boolean,
    exploreTemplateID: Number,
    exploreAlphabets: String,
    exploreLastNames: String,
    notHomepage: Boolean,
    currentExplorePage: String
  },
  components: {
    ProjectCard
  },
  mixins: [visibility, homepageStrings, yscStrings, ajasStrings, auth, features],
  data: function () {
    return {
      isScrollable: false,
      divTarget: 1,
      scrollLeft: 0,
      subSelected: {},
      newestActive: false, // Check if newest column is the active column & default on it for return from new stories
      activeTab: this.title,
      showSubMenu: false,
      counterSubMenu: 0,
      isLoading: false,
      pinnedProjects: [],
      placeholderProjects: [{ id: -1 }, { id: -2 }, { id: -3 }, { id: -4 }, { id: -5 }, { id: -6 }, { id: -7 }, { id: -8 }]
    }
  },
  computed: {
    isProjectPlaceholder: function () {
      return this.projects && this.projects.length > 0 && JSON.stringify(this.projects) === JSON.stringify(this.placeholderProjects)
    },
    shouldDisplayNewestTab: function () {
      // if you are on make and not admin newest tab will not be shown
      return !(this.$isMake && !this.isAdmin)
    },
    showSubDropdown: function () {
      const width = breakpoints.getWidth()
      return width <= 1170
    },
    category: function () {
      if (this.$store.getters.categoriesLoaded) {
        const category = this.$store.getters.categoryBySlug(this.categorySlug)
        if (category) {
          return category
        }
      }
      return 0
    },
    isLoggedIn: function () {
      return this.$store.getters.currentUser.userName
    },

    newestTitle: function () {
      return this.$isStories ? i18n.t('homepage.latest') : i18n.t('homepage.newestProjects')
    },
    bookmarkedTitle: function () {
      return i18n.t('homepage.bookmarkedProjects')
    },
    featuredTitle: function () {
      return i18n.t('homepage.featuredProjects')
    },
    premiumTitle: function () {
      return i18n.t('homepage.premium')
    },
    isIsefHome: function () {
      return this.$route.path.includes('home') && this.$isIsef
    },
    isIsefViewAll: function () {
      return this.$route.path.includes('viewAll') && this.$isIsef && this.$route.params.profile !== 'mine'
    },
    isYscHome: function () {
      return this.$route.path.includes('home') && this.$isYSC
    },
    isYscViewAll: function () {
      return this.$route.path.includes('viewAll') && this.$isYSC && this.$route.params.profile !== 'mine'
    },
    noProjectsForFilter: function () {
      return (this.isIsefHome || this.isIsefViewAll || this.isYscHome || this.isYscViewAll) && this.projectsLoadedForCategory
    },
    subCategories: function () {
      return this.$store.getters.subCategoriesForID(this.category.id)
    },
    categoryFullName: function () {
      if (this.$isGirlsAndSteam) {
        return this.activeTab.name
          ? ((this.activeTab.name.replace(/_/g, ' ')).replace('%3A', ':')).replace('pst', 'PST')
          : ((this.activeTab.replace(/_/g, ' ')).replace('%3A', ':')).replace('pst', 'PST')
      }

      if (this.$isYSC) {
        if (this.activeTab.includes(this.OUTSTANDING)) {
          return i18n.t('explore.outstandingProjects')
        } else if (this.activeTab.includes(this.REGIONAL)) {
          return i18n.t('explore.seeAllRegional')
        } else if (this.activeTab.includes(this.CHALLENGE)) {
          return i18n.t('explore.seeAllChallenge')
        } else if (this.activeTab.includes(this.YSC)) {
          return i18n.t('explore.seeAllYsc')
        }
      }
      if (typeof this.activeTab === 'string' && this.activeTab.includes(this.FEATURED_KEY)) {
        return i18n.t(this.FEATURED_KEY)
      } else if (typeof this.activeTab === 'string' && this.activeTab.includes(this.PREMIUM_KEY)) {
        return i18n.t(this.PREMIUM_KEY)
      } else if (typeof this.activeTab === 'string' && this.activeTab.includes(this.NEWEST_KEY)) {
        return i18n.t(this.NEWEST_KEY)
      } else if (typeof this.activeTab === 'string' && this.activeTab.includes(this.BOOKMARKED_KEY)) {
        return i18n.t(this.BOOKMARKED_KEY)
      } else if (typeof this.activeTab === 'string' && this.activeTab.includes(this.CONTRIBUTED_TO_KEY)) {
        return i18n.t(this.CONTRIBUTED_TO_KEY)
      } else if (typeof this.activeTab === 'string' && this.activeTab.includes(this.WETTBEWERBE_PROJECT_KEY)) {
        return this.WETTBEWERBE_PROJECT_KEY
      } else if (typeof this.activeTab === 'string' && this.activeTab.includes(this.AWARDED_PROJECTS)) {
        return this.AWARDED_PROJECTS
      }
      return this.activeTab.name ? this.activeTab.name : this.activeTab
    },
    isStemExpo: function () {
      return this.$route.path.replace('/', '') === 'stem-expo'
    },
    isStemHall: function () {
      return this.$route.path.replace('/', '') === 'stem-experiential-hall'
    },
    isCareerHall: function () {
      return this.$route.path.replace('/', '') === 'career-hall'
    },
    isCollegeHall: function () {
      return this.$route.path.replace('/', '') === 'college-hall'
    },
    isMobile: function () {
      return breakpoints.isMobile()
    },
    isIOS: function () {
      return userAgent.isIOS()
    },
    isIE: function () {
      return userAgent.isIE11()
    },
    isEdgeLegacy: function () {
      return userAgent.isEdge()
    },
    isSafari: function () {
      return userAgent.isSafari()
    },
    viewportWidth: function () {
      return document.documentElement.clientWidth
    },
    cardWidth: function () {
      if (!this.$isIsef) {
        return this.viewportWidth > this.tabletWidth ? this.engCardAreaWidth : this.engCardAreaWidthMobile
      } else {
        return this.viewportWidth > this.tabletWidth ? this.isefCardWidth : this.isefCardWidthMobile
      }
    },
    canScrollLeft: function () {
      return this.scrollLeft > 0
    },
    canScrollRight: function () {
      if (this.$refs.row) {
        return this.scrollLeft + this.$refs.row.clientWidth < this.$refs.row.scrollWidth - this.seeAllDivWidth
      }
      return false
    },
    categoryID: function () {
      return this.category ? this.category.id : 0
    },
    subCategoryID: function () {
      return this.subSelected ? this.subSelected.id || 0 : 0
    },
    storiesOrBoards: function () {
      if (!this.title.includes(this.OUTSTANDING) && !this.title.includes(this.REGIONAL) && !this.title.includes(this.CHALLENGE) && !this.title.includes(this.YSC)) {
        return this.$isEngCom ? i18n.t('homepage.stories') : i18n.t('homepage.projects')
      }
    },
    appName: function () {
      return process.env.APP_NAME.toLowerCase()
    },
    browsingYear: function () {
      return this.$route.params.year
    },
    currentYear: function () {
      return new Date().getFullYear()
    },
    noProjectsMessage: function () {
      switch (this.appName) {
        case 'ysc':
          if (this.currentYear > this.browsingYear) {
            return i18n.t('explore.noProjectsGeneral')
          } else {
            return this.yscErrorMessages(this.displayTitle)
          }
        case 'ajas':
          return this.ajasErrorMessages(this.displayTitle)
        default:
          return 'No projects to display at the moment.'
      }
    },
    categoriesLoaded: function () {
      return this.$store.getters.categoriesLoaded
    },
    displayTitle: function () {
      if (this.$isGirlsAndSteam) {
        return (this.title.replace('%3A', ':')).replace(/_/g, ' ')
      }

      if (this.title === this.STEM_EXPO) {
        return i18n.t('explore.stemExpo')
      } else if (this.title === this.LASSONDE_BOOTCAMP) {
        return i18n.t('explore.lassondeBootcamp')
      } else if (this.title === this.REGIONAL_AWARDS) {
        return i18n.t('explore.regionalAwards')
      } else if (this.title === this.CHALLENGE_AWARDS) {
        return i18n.t('explore.challengeAwards')
      } else if (this.title === this.YSC_AWARDS) {
        return i18n.t('explore.yscAwards')
      } else {
        if (this.categorySlug && this.$isYSC && this.categoriesLoaded) {
          const category = this.$store.getters.categoryBySlug(this.categorySlug)
          if (category) {
            return category.name
          }
        }
        if (this.title === 'navBar.contributedTo') {
          return i18n.t(this.title)
        }
        return this.title
      }
    },
    buttonTitle: function () {
      if (this.isMobile) {
        return i18n.t('explore.submitProject').split(' ').shift()
      } else {
        return i18n.t('explore.submitProject')
      }
    },
    isAcceptingProjects: function () {
      return this.category.acceptingProjects
    },
    isPinnableRow: function () {
      const isCategoryWithNoSubcategories = (typeof this.category === 'object' && this.subCategories.length === 0)
      const isSelectedSubcategoryTab = (Object.keys(this.subSelected).length !== 0)

      return isCategoryWithNoSubcategories || isSelectedSubcategoryTab
    },
    activeCategoryID: function () {
      return this.subCategoryID || this.categoryID
    },
    hasParentCategory: function () {
      return this.category && this.category.parentID > 0
    },
    showSponsorLogo: function () {
      if (this.category === undefined || this.category === 0) {
        return false
      }
      return this.$isIsef ? this.category.sponsorImage !== '' : this.category.sponsor !== ''
    },
    projectsLoadedForCategory: function () {
      return this.$store.getters.getProjectLoadingStatusByCategory(this.categorySlug) === 'loaded'
    },
    userFilterIsActive: function () {
      return this.$store.getters.userFilterTagsIsActive
    },
    isViewNewestTabPermission: function () {
      return this.hasFeature('SeeNewestTab') || this.shouldDisplayNewestTab
    }
  },
  created: function () {
    this.featureGroupName = 'Home Page'
    this.getFeatures()
  },
  mounted: function () {
    this.checkIfScrollable()
    if (this.rowState) {
      if (this.rowState.scrollLeftpos) {
        this.$refs.row.scrollLeft = this.rowState.scrollLeftpos
      }
      if (this.rowState.subCategoryID) {
        this.subSelected = this.$store.getters.categoryByID(this.rowState.subCategoryID)
      }
      if (this.rowState.pinnedProjects) {
        this.pinnedProjects = this.rowState.pinnedProjects
      }
    }
    this.$store.dispatch('setCurrentActivePageValue', this.currentExplorePage)
  },
  watch: {
    projects: function () {
      this.$nextTick(() => {
        this.getPinnedProjects()
        this.checkIfScrollable()
        this.isLoading = false
      })
    },
    activeCategoryID: function () {
      this.getPinnedProjects()
    }
  },
  methods: {
    checkIfScrollable: function () {
      this.isScrollable = false
      if (this.projects?.length > 0 && !!this.$refs.row) {
        this.isScrollable = this.$refs.row.scrollWidth > this.$refs.row.clientWidth
      }
    },
    getState: function () {
      return {
        projectIDs: this.projects.map((p) => { return p.id }),
        pinnedProjects: this.pinnedProjects,
        scrollLeftpos: this.scrollLeft,
        subCategoryID: this.subCategoryID
      }
    },
    viewAllCategory: function (tab) {
      if (this.notHomepage) {
        this.$emit('parentSelectCategory', tab)
        return
      }
      const category = this.$store.getters.categoryByName(tab)
      if (typeof tab === 'string' && tab?.includes(this.FEATURED_KEY)) {
        this.$router.push({ name: 'viewAll', query: { category: this.FEATURED } })
      } else if (tab === this.PREMIUM_KEY) {
        this.$router.push({ name: 'viewAll', query: { category: this.PREMIUM } })
      } else if (tab === this.NEWEST_KEY) {
        this.$router.push({ name: 'viewAll', query: { category: this.NEWEST } })
      } else if (this.$route.name === 'explore-page') {
        this.$router.push({ name: 'viewAll', query: { templateID: this.exploreTemplateID, title: tab, exploreAlphabets: this.exploreAlphabets, exploreLastNames: this.exploreLastNames } })
      } else if (tab === this.BOOKMARKED_KEY) {
        this.$router.push({ name: 'viewAll', query: { category: this.BOOKMARKED } })
      } else if (tab === this.RECENT_ACTIVITY) {
        this.$router.push({ name: 'viewAll', query: { category: this.RECENT_ACTIVITY } })
      } else if (tab === this.CONTRIBUTED_TO_KEY) {
        this.$router.push({ name: 'viewAll', query: { profile: 'contributed' } })
      } else if (tab === this.WETTBEWERBE_PROJECT) {
        this.$router.push({ name: 'viewAll', query: { category: category.slug } })
      } else if (tab === this.SPONSORS_KEY) {
        const subEvent = this.$route.path.substring(1)
        this.$router.push({ name: 'viewAll', query: { templateIDs: '[126080,126081]', title: tab, page: subEvent } })
      } else if (([this.SD_AWARDED_PROJECTS, this.AWARDED_PROJECTS, this.SD_SUPERIOR_AWARDS].includes(tab)) && this.$isOhioScience) {
        const subEvent = this.$route.path.substring(1)
        this.$router.push({ name: 'viewAll', query: { awarded: true, page: subEvent } })
      } else if (tab === this.AWARDED_PROJECTS) {
        this.$router.push({ name: 'viewAll', query: { awarded: 'cnmi' } })
      } else if (tab === this.STEM_EXPO) {
        this.$router.push({ name: 'viewAll', query: { tag: this.STEM_EXPO_HASHTAG } })
      } else if (tab === this.LASSONDE_BOOTCAMP) {
        this.$router.push({ name: 'viewAll', query: { tag: this.LASSONDE_HASHTAG } })
      } else if (typeof tab === 'string' && tab?.includes('STEM Expo Tier 1')) {
        this.$router.push({ name: 'viewAll', query: { templateIDs: '[58792,57628]', title: tab } })
      } else if (typeof tab === 'string' && tab?.includes('STEM Expo Tier 2')) {
        this.$router.push({ name: 'viewAll', query: { templateIDs: '[58866,58791]', title: tab } })
      } else if (typeof tab === 'string' && tab?.includes('Regeneron ISEF 2023 Top Award')) {
        this.$router.push({ name: 'viewAll', query: { awardID: 280, title: tab } })
      } else if (typeof tab === 'string' && tab?.includes('Regeneron ISEF 2023 Grand Award')) {
        this.$router.push({ name: 'viewAll', query: { awardID: 279, title: tab } })
      } else if (typeof tab === 'string' && tab?.includes('Regeneron ISEF 2023 Special Award')) {
        this.$router.push({ name: 'viewAll', query: { awardID: 281, title: tab } })
      } else if (tab === this.AJAS_SPONSORS) {
        this.$router.push({ name: 'viewAll', query: { tag: this.AJAS_SPONSORS_HASHTAG } })
      } else if (this.$isYSC && (tab === 'string' && (tab?.includes(this.REGIONAL) || tab?.includes(this.CHALLENGE) || tab?.includes(this.YSC)))) {
        tab = tab.replace(' Awards', '')
        this.$router.push({ name: 'viewAll', query: { award: tab } })
      } else if (this.isCollegeHall || this.isStemHall) {
        tab = tab.slice(tab.length - 3)
        tab = tab.replace('-', '')
        const url = this.$route.path + '/' + tab.toLowerCase()
        this.$router.push(url)
      } else if (this.isCareerHall) {
        tab = tab.replace(' ', '-')
        tab = tab.replace(' ', '-')
        tab = tab.replace(' ', '-')
        const url = this.$route.path + '/' + tab.toLowerCase()
        this.$router.push(url)
      } else {
        if (category) {
          if (!category.subCategories) {
            if (this.$isOhioScience) {
              const subEvent = this.$route.path.substring(1)
              this.$router.push({ name: 'viewAll', query: { category: category.slug, page: subEvent } })
            } else {
              this.$router.push({ name: 'viewAll', query: { category: category.slug } })
            }
          } else {
            this.$emit('viewCategory', category.name)
          }
        } else if (tab.slug && !tab.subCategories) {
          this.$router.push({ name: 'viewAll', query: { category: tab.slug } })
        } else if (tab.slug) {
          this.$emit('viewCategory', tab.slug)
        } else {
          tab = tab === this.OUTSTANDING_PROJECTS ? this.OUTSTANDING : tab
          this.$emit('viewCategory', tab)
          if (this.$isYSC) {
            this.$router.push({ name: 'viewAll', query: { type: 'custom', method: 'getYscAwardProjects', title: tab } })
          } else {
            this.$emit('viewCategory', tab)
          }
        }
      }
    },
    changeSubCategory: function (tab, mobile) {
      this.isLoading = true
      this.showSubMenu = false
      const params = { refresh: true }
      let shouldFetch = true
      if (tab === this.activeTab || (typeof this.activeTab === 'string' && this.activeTab.startsWith(tab))) {
        if (mobile) {
          params.slug = this.categorySlug
          this.activeTab = this.title
          this.subSelected = {}
        } else {
          shouldFetch = false
          if (typeof tab === 'string') {
            this.viewAllCategory(tab)
          } else {
            this.viewAllCategory(tab.name)
          }
        }
      } else {
        if (tab === this.FEATURED_KEY) {
          params.slug = 'featuredProjects'
        } else if (tab === this.NEWEST_KEY) {
          params.slug = 'latestProjects'
        } else if (tab === this.BOOKMARKED_KEY) {
          params.slug = 'bookmarkedProjects'
        } else if (tab === this.OUTSTANDING) {
          params.slug = 'outstandingProjects'
        } else if (tab === this.REGIONAL) {
          params.slug = 'regionalProjects'
          params.awardID = 1
        } else if (tab === this.CHALLENGE) {
          params.slug = 'challengeProjects'
        } else if (tab === this.YSC) {
          params.slug = 'yscProjects'
          params.awardID = 2
        } else if (tab.slug) {
          const redirectParent = this.subSelected && this.subSelected.id === tab.id && tab.subCategories && tab.subCategories.length > 0
          this.subSelected = tab
          params.slug = tab.slug
          params.pinned = this.isPinnableRow
          if (redirectParent) {
            this.viewAllCategory(tab.name)
          } else {
            this.$emit('fetchSub', tab.slug)
            shouldFetch = false
          }
        } else {
          // clicked on parent so clear selected sub category
          this.subSelected = {}
          params.pinned = this.isPinnableRow
        }
        this.activeTab = tab
      }
      if (shouldFetch) {
        this.$emit('fetch', this.offset, this.rowType, params)
      }
    },
    scrollTo (div) {
      this.$refs.row.querySelector(`div:nth-child(${div})`).scrollIntoView({
        behavior: this.isSafari ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'start'
      })
    },
    onVisible: function () {
      if (this.offset !== undefined) {
        this.$emit('fetch', this.offset, this.rowType, { pinned: this.isPinnableRow })
      }
    },
    horizontalScroll: function (dir) {
      if (this.isIE || this.isEdgeLegacy || this.isMobile) {
        const scrollDistance = 200
        this.$refs.row.scrollLeft = dir === 'right' ? this.$refs.row.scrollLeft + scrollDistance : this.$refs.row.scrollLeft - scrollDistance
        return
      }
      if (this.viewportWidth < 1800) {
        this.$refs.row.scrollLeft = dir === 'right' ? this.$refs.row.scrollLeft + this.cardWidth : this.$refs.row.scrollLeft - this.cardWidth
        return
      }
      const numberOfCardsVisible = Math.floor(this.viewportWidth / this.cardWidth) - 1
      const totalCards = this.projects.length
      if (dir === 'right') {
        this.divTarget = (this.divTarget + numberOfCardsVisible <= totalCards && this.$refs.row.scrollWidth - this.$refs.row.offsetWidth !== this.$refs.row.scrollLeft) ? this.divTarget + numberOfCardsVisible : totalCards
      }
      if (dir === 'left') {
        this.divTarget = (this.divTarget > numberOfCardsVisible) ? this.divTarget - numberOfCardsVisible : 1
      }
      this.scrollTo(this.divTarget)
    },
    handleScroll: function () {
      this.scrollLeft = this.$refs.row.scrollLeft
    },
    openMakerTemplate: function (title) {
      const category = this.$store.getters.categoryByName(title)
      if (category) {
        const slug = category.slug
        const parentCategory = this.$store.getters.categoryByID(category.parentID)
        const query = { startButton: true, draft: true }
        if (parentCategory.slug === 'contests' || parentCategory.slug === 'growing-beyond-earth') {
          if (category.slug === 'yokogawa-ert3-challenge' || category.slug.startsWith('gbe-')) {
            query.hidden = true
          }
        } else {
          query.private = true
          query.hidden = true
        }
        this.$router.push({ path: `/start/${slug}`, query })
      }
    },
    getTooltip: function (rowName) {
      if (rowName === 'AR/VR' || rowName === 'PLM/ERP' || rowName === 'IoT' || rowName === 'BIM') {
        const tooltip = {}

        switch (rowName) {
          case 'AR/VR':
            tooltip['data-balloon'] = 'Augmented Reality / Virtual Reality'
            break
          case 'PLM/ERP':
            tooltip['data-balloon'] = 'Product Lifecycle Management / Enterprise Resource Planning'
            break
          case 'IoT':
            tooltip['data-balloon'] = 'Internet of Things'
            break
          case 'BIM':
            tooltip['data-balloon'] = 'Building Information Modeling'
        }

        tooltip['data-balloon-pos'] = 'up'

        return tooltip
      }
    },
    getPinnedProjects: function () {
      this.pinnedProjects = this.$store.getters.pinnedProjects?.[this.activeCategoryID] || []
    },
    onPinned: function (isPinned) {
      const params = { refresh: true, slug: this.activeTab.slug || this.categorySlug, pinned: true }
      this.$emit('fetch', this.offset, this.rowType, params)
      isPinned && this.horizontalScroll('left')
    },
    getParentName: function () {
      const parentCategory = this.$store.getters.categoryByID(this.category.parentID)
      if (parentCategory && parentCategory.name && this.showParent) {
        return i18n.t('sectionHome.in') + ' ' + parentCategory.name
      }
      return ''
    },
    proxyCatImage: function (src) {
      return imageProxy.proxy(src, { width: 35, height: 35 })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  ::-webkit-scrollbar {
    display: none;
    background: transparent;
  }
  .project-sponsor-spacing {
    margin-left: 15px;
    padding: .5rem 0;
  }
  .project-sponsor-image {
    height: 33px !important;
    width: auto !important;
    @media only screen and (max-width: 500px) {
      margin-top: .1rem !important;
    }
  }
  .fixed-row-height {
    height: 21rem;
  }
  .row {
    margin-top: 1.5rem;
    margin-left: 1rem;
    overflow-x: -moz-scrollbars-none;
    -ms-overflow-style: none;
    &_stem-expo {
      background-color: #ececec;
      margin-left: -1.3rem;
      background-image: linear-gradient(#ececec, white);
    }
  }

  .isef {
    color: white !important;
    border-color: white !important;
    font-family: 'Trade Gothic Next LT Pro BdCn',serif !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 34px !important;
    text-transform: capitalize !important;
    line-height: 43px !important;
    padding-right: 20px;
    @media only screen and (max-width: 500px){
      font-size: 24px !important;
      margin-right: -1.8rem !important;
    }
  }

  .category-header {
    width: 100%;
    display: flex;
    a {
      margin-left: 15px;
    }
    .has-award-icon {
      a {
        margin-left: 5px;
      }
    }
    font-size: .875rem;
    color: #4A4A4A;
    letter-spacing: 0.32px;
    text-align: center;
    line-height: 24px;

    &_project-border {
      border-bottom-color: var(--background-third) !important;
      display: flex;
      flex-direction: row;
    }
  }
  .tabs {
    white-space: normal;
    overflow: visible;
    &-isef {
      font-family: 'Trade Gothic Next LT Pro BdCn',sans-serif;
      font-style: normal;
      font-weight: 700;
      font-size: 26px;
      line-height: 33px;
      color: #FFFFFF;
      padding-top: .3rem;
    }

    ul {
      border-bottom-width: 1px;
    }
    a {
      margin-bottom: 0;
      border-bottom-width: 0;
      padding: .5rem 0;
      position: relative;
      bottom: -1px;
      &:not(.ysc):hover {
        border-color: $primary;
        border-bottom-width: 1px;
        padding-bottom: 7px;
      }
      &.ysc:hover:before {
        content: "";
        background: #663AB6;
        position: absolute;
        left: 0;
        bottom: 0;
        height: 2px;
        width: 60px;
      }
    }
    .is-active {
      a {
        position: relative;
      }
      a:before {
        content: "";
        background: $primary;
        position: absolute;
        left: 0;
        bottom: 0;
        height: 1px;
        width: 100%;
      }
      a.ysc:before {
        background: #663AB6;
        height: 2px;
        width: 60px;
      }
      a:not(.ysc):hover:before {
        height: 0;
      }
    }
  }
  .featured-and-newest {
    display: flex;
    font-weight: normal;
    text-transform: uppercase;
    font-size: 1rem;
    li {
      display: flex;
      align-items: center;
    }
    .line {
      padding-left: 10px;
      font-weight: bold;
    }
    a {
      color: var(--background-third);
      align-items: stretch;
      padding: 10px 0;
    }
    .main-title {
      margin-left: 0;
    }
    .is-active {
      font-weight: bold;
      a {
        color: var(--background-third);
      }
    }
  }
  .category-title {
    color: $dark;
    font-weight: bold;
    display: flex;
    &-isef {
      @media only screen and (max-width: 550px) {
        justify-content: center !important;
        align-items: center !important;
        align-content: center !important;
      }
    }
    .category-header{
      border-bottom: 2px solid #dbdbdb
    }
    .main-title {
      text-transform: uppercase;
      font-size: 1.03rem;
      color: var(--background-third);
      margin-left: 0;
      padding-bottom: .5rem;
    }
  }
  .view-more {
    justify-content: center;
    flex-direction: column;
    text-align: center;
    padding: 0 4.5rem 0 0;
    margin-left: 2rem;
    font-size: 0.6rem;
    min-width: 8.5rem;
    width: 8.5rem;
    &_text {
      color: white;
      font-size: 1em;
      @include mobile{
        font-size: inherit;
      }
    }
    @include mobile {
      padding: 0 1.5rem;
      margin-left: 0;
    }
    .view-category {
      width: 100%;
      margin-top: 0.7rem;
      text-decoration: underline;
      font-size: 0.8rem;
    }
  }
  .project-button {
    background: $primary;
    color: white;
    border: none;
    padding: 0.4rem 0.8rem;
    text-transform: uppercase;
    font-size: 0.75rem;
    margin-left: 1.5rem;
    font-weight: 500;
    border-radius: 2px;
    cursor: pointer;
    &:hover {
      background: darken($primary, 2.5%)
    }
  }
  .button-container {
    z-index: 8;
    left: 0;
    right: 0;
    position: absolute;
    pointer-events: none;
    margin-top: 1rem;
    // ensure the scroll buttons match the height of the card
    height: 201px; // Mobile card height

    &_stemexpo {
      height: 365px !important;
      &-large {
        height: 410px !important;
      }
    }
    @include tablet-only {
      height: 221px;
    }
    @media (min-width: 1024px) {
      height: 270px;
    }
    i {
      color: #fff;
    }
    .scroll-button {
      height: 100%;
      width: 2rem;
      pointer-events: auto;
      align-items: center;
      justify-content: center;
      background-color: var(--background-third);
      padding: 0.6rem 0.1rem;
      position: absolute;
      opacity: 0.4;
      transition: 0.2s;
      &:hover {
        opacity: 0.7;
      }
      &-isef {
        opacity: 1 !important;
        width: 56px !important;
        height: 72px !important;
        margin: 0 .5rem;
        background: rgba(255, 255, 255, 0.12) !important;
        border: 1px solid rgba(255, 255, 255, 0.6);
        backdrop-filter: blur(24px);
        border-radius: 12px;
        @media only screen and (max-width: 550px) {
          top: 26%
        }
      }
    }
    .left {
      left: 0
    }
    .right {
      right: 0;
    }
  }
  .category-image-container {
    align-items: center;
    min-width: 35px;
    min-height: 30px;
    margin-right: 10px;
  }
  .category-image {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    &-isef {
      width: 50px !important;
      height: 50px !important;
    }

    &_star {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      background-color: orange;
      padding: 1rem;
      border-radius: 50%;
      height: 40px;
      width: 40px;
      color: white;
    }
  }
  .card-row {
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 0.8rem;
    width: 99%;
    &-isef {
      -ms-overflow-style: none;  /* Internet Explorer 10+ */
      scrollbar-width: none;
      @include mobile {
        gap: .5rem;
      }
    }
  }
  .no-projects {
    padding: 1.5rem 0 2rem;
  }
  .no-projects-isef {
    color: white;
  }
  .subcategory-list {
    .small-ribbon {
      margin-left: 15px;
      width: 18px;
    }
  }
  .category-title {
    .small-ribbon {
      margin-right: 15px;
      width: 18px;
    }
  }

  .button {
    padding-right: 1.75rem;
  }
  .category-header {
    width: 95%;
    border-bottom: 1px solid #dbdbdb
  }
  .tabs {
    ul {
      border-bottom-width: 0;
      max-width: 55%;
    }
    .is-active a {
      border-bottom: 0;
      overflow-x: visible;
    }
    .dropdown a:before {
      background: none;
    }
    .dropdown-item {
      display: flex;
      padding: 10px;
      justify-content: space-between;
      .is-active a {
        color: white;
      }
    }
  }
  .tabs.ysc {
    ul:not(.featured-and-newest) {
      max-width: 100%;
    }
  }
  .dropdown {
    align-items: center;
    .sub-button {
      border: none;
      background: none;
    }
  }
  .dropdown-content {
    margin-top: -1rem;
  }
  .dropdown-menu {
    z-index: 9;
    max-height: 200px;
    overflow-y: auto;
  }
  .category-title {
    display: flex;
    align-items: center;
    .sub-button {
      border: none;
      background: none;
      height: inherit;
      padding-bottom: 0;
      padding-top: 0;
    }
    .sub-close {
      position: absolute;
      right: 0.75rem;
      line-height: 1.5;
    }
    a.is-active {
      color: $white;
    }
  }
  @include mobile {
    .row {
      margin-left: 0;
    }
    .featured-and-newest {
      font-size: .9rem;
      max-width: 100% !important; // Overwriting the Bulma tabs !important
      a {
        border-bottom: 0;
        margin-left: 5px;
      }
      .line {
        padding-left: 5px;
        font-weight: bold;
      }
    }
    .category-title {
      .main-title {
        font-size: .9rem;
      }
    }
    .button {
      padding-right: 0.75rem;
    }
  }

  @media (max-width: 670px) {
    .category-header {
      text-align: left;
    }
    .ysc {
      width: 100%;
      font-size: 10px;
      .category-title {
        margin-right: 1rem;
      }
      ul:not(.featured-and-newest) {
        .main-title {
          justify-content: flex-start;
          text-align: left;
        }
      }
    }
    .subcategory-list {
      a {
        line-height: 1rem;
        margin-left: 0;
      }
      .small-ribbon {
        margin-left: 5px;
      }
    }
  }
  @media (max-width: 435px) {
    .ysc {
      ul:not(.featured-and-newest) {
        .main-title {
          height: 63px;
          align-items: flex-end;
        }
      }
      .subcategory-list {
        a {
          margin-left: 0;
        }
        .small-ribbon {
          margin: 0 5px;
        }
      }
    }
    .category-title {
      align-items: flex-end;
      .small-ribbon {
        margin-bottom: 0.5rem;
      }
    }
  }

  @media (max-width: 414px) {
  .sponsor-image {
    padding-left: 15px !important;
    padding-bottom: 5px !important;
    max-height: 32px !important;
    max-width: 100px !important;
  }

    .sub-category-title {
      white-space:pre-line !important;
      min-width: 114px !important;
    }
  }

  @media (max-width: 320px) {
    .ysc {
      .subcategory-list {
        .small-ribbon {
          display: none;
        }
      }
    }
  }
  .empty-row-spacing{
    padding-top: 1rem;
    padding-left: 1rem;
    height: 150px;
    width: 100%;

    &_text {
      color: white;
    }
    /*background: white;*/
  }
  .sponsor-image {
    max-height: 55px;
    max-width: 140px;
  }

  .sub-category-title {
    white-space: nowrap;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    margin-left: 0.5rem;
    color: var(--font-colour);
    @include mobile {
      margin: 0 0 0.5rem 0.5rem;
    }
  }
  .tabs div .hover-sponsor:hover {
    border-color: transparent;
  }
  .isef {  // change this code for hover effect in isef titles
    a.main-title {
      bottom: 0px;
      &:hover {
        border-color: white;
        border-bottom-width: 0px;
        padding-bottom: 0.5rem;
      }
      @media only screen and (max-width: 550px) {
        max-width: 15rem;
        line-height: 1.55rem !important;
      }
    }
  }

  .sponsor_box {
    position: relative;
    margin-left: 280px;
    top: 37px;

  &_logo {
    width: 90px;
    height: 20px;
    margin-top: 1px;
    margin-left: 1px;
  }
}
  .loader {
    font-size: 5rem;
    margin: 2rem auto;
  }
  .loader-container {
    padding-bottom: 1rem;
  }
  .no-wrap {
    white-space: pre;
    @media only screen and (max-width: 550px){
      white-space: normal;
    }
  }
  .sponsored-by {
    margin-right: 0.5rem;
    font-color: #555555;
    font-size: 14px;
    font-weight: 400;
  }
  .yscFilters {
    font-color: #000000;
  }
</style>
